<template>
    <MetricsDashboard :entity-id="entityId" :entity-type="entityType">
        <template #child-section="{ hours, stekRelease, entityId: domainId }">
            <AllProductsSection
                v-if="domainId"
                :domain-id="domainId"
                :hours="hours"
                :stek-release="stekRelease"
            />
        </template>
    </MetricsDashboard>
</template>

<script setup lang="ts">
import AllProductsSection from "./AllProductsSection.vue";
import MetricsDashboard from "./MetricsDashboard.vue";

defineOptions({
    name: "DomainDashboard",
});

defineProps<{
    entityId: string;
    entityType: string;
}>();
</script>
